import Icons from "@/src/components/Icons";
import { foodApi } from "@/src/utils/api/food";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Estimate() {
  let history = useNavigate();
  const [data, setData] = useState([]);
  useEffect(() => {
    foodApi.estimate().then((res) => {
      setData(res.data);
    });
  }, []);
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer mb-4"
        onClick={() => history("/profile")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        برنامه هفتگی و تخمین
      </h4>
      <div>
        <div className="w-full shadow-mmpz flex items-center px-8 py-3">
          <div className="item w-1/4 text-sm ">روز و تاریخ</div>
          <div className="item w-1/4 text-sm text-center">نام غذا</div>
          <div className="item w-1/3 text-sm text-center">شرکت</div>
          <div className="item w-1/6 text-sm text-end ">تخمین</div>
        </div>
        {data &&
          data.length > 0 &&
          data.map((item: any) => {
            return (
              <div className="body flex flex-col gap-3">
                <div className="item shadow-mmpz py-4 flex justify-between mt-4 p-2 rounded-xl px-8 items-center">
                  <div className="item w-1/4 text-xs flex items-center text-center justify-start flex-col text-gray-300-mmpz">
                    {digitsEnToFa(moment(item.date).format("jYYYY-jMM-jDD"))}
                    <br />
                    <span className="text-gray-200-mmpz">
                      {" "}
                      {digitsEnToFa(moment(item.date).format("ddd"))}
                    </span>
                  </div>
                  <div className="item w-1/4 text-xs flex items-center justify-center px-2 text-center">
                    {item.foodName}
                  </div>
                  <div className="item w-1/3 text-xs flex items-center justify-center px-2 text-center">
                    {item.enterpriseName}
                  </div>
                  <div className="item w-1/6 text-xs text-end items-center flex justify-end text-gray-300-mmpz font-bold">
                    {digitsEnToFa(item.estimate)}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Estimate;
